import React from "react";
import "./ProfileDetails.css";
import { useGlobalContext } from "../../../context/context";
import { FiEdit2 } from "react-icons/fi";

const show = (value) => value === null || value === undefined || value === "" ? "Not provided" : value;

const ProfileDetails = ({ onEdit }) => {
  const { userDetails } = useGlobalContext();
  const details = userDetails && !Array.isArray(userDetails) ? userDetails : {};
  const {
    firstName, lastName, email, gender, dob, maritalStatus, maritalstatus,
    city, country, phone, address, symbol,
  } = details;
  const rows = [
    ["First name", firstName],
    ["Last name", lastName],
    ["Email address", email],
    ["Phone number", phone],
    ["Gender", gender],
    ["Date of birth", dob],
    ["Marital status", maritalStatus || maritalstatus],
    ["City", city],
    ["Country", typeof country === "string" ? country : country?.name],
    ["Address", address],
    ["Account currency", symbol || country?.symbol],
  ];

  return (
    <section className="profile_details pg-profile-details">
      <header className="pg-panel-heading">
        <div><span className="pg-kicker">YOUR INFORMATION</span><h2>Profile details</h2><p>Personal information associated with your account.</p></div>
        {onEdit && <button type="button" className="pg-panel-edit" onClick={onEdit}><FiEdit2 size={14} /> Edit profile</button>}
      </header>
      <dl className="pg-detail-grid">
        {rows.map(([label, value]) => (
          <div className="pg-detail-item" key={label} data-testid={`profile-${label.toLowerCase().replaceAll(" ", "-")}`}>
            <dt>{label}</dt><dd>{show(value)}</dd>
          </div>
        ))}
      </dl>
      <p className="pg-details-note">For your security, account credentials are managed separately.</p>
    </section>
  );
};

export default ProfileDetails;
